/* eslint-disable */
import React from 'react';
import {
    SimpleGrid,
    Grid,
    Button
  } from '../../../components/index';
import {doGetFileMsgPagamento} from '../../../utils/requests';



export const DownloadArquivoMsg = function(props) {
  // console.log(props.arquivos)
  return(
    <React.Fragment>
      <SimpleGrid>
      <div className="row">
      {props.arquivos.map((arquivo, key) => (

          
          <Grid cols="2" style={{textAlign: "center"}}>
            <Button
              flat={true}
              mini='true'
              hint="baixar arquivo"
              icon="ico-download"
              onClick={() => doGetFileMsgPagamento(arquivo.idDocumento, arquivo.legenda)}
            />
            <span>{arquivo.legenda}</span>
          </Grid>
                ))}
                        </div>
     

      </SimpleGrid>
    </React.Fragment>
  )
}




// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/DownloadArquivoMsg.jsx